import React from "react";
import HighlightedText from "../../../../components/HighlightKeyword";

export default function GlobalTable({
  documentList,
  openModal,
  query,
  getArrowIcon,
  handleSortGlobal,
}) {
  return (
    <table className="case-law-table">
      <thead>
        <tr>
          <th style={{ width: "150px" }}>
            <div
              className="case-law-table-header"
              onClick={() => handleSortGlobal("no")}
            >
              Act No/Gazette No {getArrowIcon("no")}
            </div>
          </th>
          <th style={{ minWidth: "20vw" }}>
            <div
              className="case-law-table-header"
              onClick={() => handleSortGlobal("titleBI")}
            >
              Title {getArrowIcon("titleBI")}
            </div>
          </th>
          <th style={{ width: "150px" }}>
            <div
              className="case-law-table-header"
              onClick={() => handleSortGlobal("publicationDate")}
            >
              Publication Date {getArrowIcon("publicationDate")}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {documentList.map((item) => (
          <tr key={item.documentId}>
            <td>{item?.no}</td>
            <td>
              <HighlightedText
                paragraph={item?.titleBI ? item.titleBI : item.titleBM}
                keyword={query}
                onClick={() => {
                  openModal(item?.fileUUID, 1);
                }}
              />
            </td>
            <td style={{ textAlign: "center" }}>
              {new Date(item?.publicationDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
